export const extractFAQSchema = (body) => {
  const faqs = [];
  const seenQuestions = new Set();

  function extractFromNode(node) {
    if (!node || typeof node !== 'object') return;

    if (Array.isArray(node?.frequentlyAskedQuestions)) {
      node.frequentlyAskedQuestions.forEach((faq) => {
        const question = faq.question;
        const answerHtml = faq?.answer?.childMarkdownRemark?.html;

        if (question && answerHtml && !seenQuestions.has(question)) {
          seenQuestions.add(question);
          faqs.push({
            '@type': 'Question',
            name: question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: answerHtml,
            },
          });
        }
      });
    }

    Object.values(node).forEach((value) => {
      if (typeof value === 'object') {
        if (Array.isArray(value)) {
          value.forEach((subItem) => extractFromNode(subItem));
        } else {
          extractFromNode(value);
        }
      }
    });
  }

  extractFromNode(body);

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs,
  };
};
